<template>
	<div id="app">
		<Header v-if="show" />
		<router-view class="router-view"></router-view>
		<Footer v-if="show" />
		<!-- 侧边栏 -->
		<right-bar />
	</div>
</template>
<script>
	import Header from '@/widget/header.vue'
	import Footer from '@/widget/footer.vue'
	import RightBar from '@/widget/right-bar.vue'
	export default {
		components: {
			Header,
			Footer,
			RightBar
		},
		data () {
			return {
				show: true
			}
		},
		watch: {
			$route (to) {
				if (to.name === '404') {
					this.show = false
				} else {
					this.show = true
				}
			}
		}
	}
</script>